export const companyInfo = {
  displayName: 'Golden Hands Home Care',
  legalName: 'Golden Hands Home Care Inc',
  phone: '(814) 710-3122',
  fax: '(814) 710-3123',
  email: 'info@goldenhandshc.com',
  hours: 'Monday - Friday, 9AM to 5PM',
  addressLine: '2405 Linglestown Rd Suite 6',
  cityStateZip: 'Harrisburg, PA 17110',
};

export const fullAddress = `${companyInfo.addressLine}, ${companyInfo.cityStateZip}`;
